/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import {
  ChangedActiveApproversQuery,
  GetChangedActiveApproversInputDto,
  GetQuittedActiveApproversInputDto,
  PerformanceFormPeriodApprovalDto,
  PerformanceFormPeriodApprovalInputDto,
  PerformanceFormPeriodApprovalRequestDto,
  QuittedActiveApproversQuery,
  SendFormApprovalReminderRequest,
  SubstituteApproversInputDto,
} from './models';
import { LinqService, QueryOptions } from 'linquest';

import { IAjaxProvider } from 'jinqu';

/**
 * PerformanceFormPeriodApprovalApi - API class
 */
export class PerformanceFormPeriodApprovalApi extends LinqService {

  /**
   * Creates a new PerformanceFormPeriodApprovalApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: PerformanceFormPeriodApprovalDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/GetAsync`;
    let query = this.createQuery<PerformanceFormPeriodApprovalDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param input 
   */
  getChangedActiveApprovers(input?: GetChangedActiveApproversInputDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/GetChangedActiveApprovers`;
    let query = this.createQuery<ChangedActiveApproversQuery>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = input;
    query = query.withOptions(options);

    return query;
  }

  /**
   * @param input 
   */
  getQuittedActiveApprovers(input?: GetQuittedActiveApproversInputDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/GetQuittedActiveApprovers`;
    let query = this.createQuery<QuittedActiveApproversQuery>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = input;
    query = query.withOptions(options);

    return query;
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/GetTranslatedAsync`;
    let query = this.createQuery<PerformanceFormPeriodApprovalDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/List`;
    let query = this.createQuery<PerformanceFormPeriodApprovalDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/ListTranslated`;
    let query = this.createQuery<PerformanceFormPeriodApprovalDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: PerformanceFormPeriodApprovalDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param performanceFormId 
   * @param performanceFromPeriodId 
   */
  sendBackToLastApprover(performanceFormId?: string, performanceFromPeriodId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/SendBackToLastApprover`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'performanceFormId', value: performanceFormId && performanceFormId.toString() });
    // set query parameters
    options.params.push({ key: 'performanceFromPeriodId', value: performanceFromPeriodId && performanceFromPeriodId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param input 
   */
  sendFormApprovalReminder(input?: SendFormApprovalReminderRequest, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/SendFormApprovalReminder`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = input;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param input 
   */
  substituteApprovers(input?: SubstituteApproversInputDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/SubstituteApprovers`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = input;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param periodApprovals 
   */
  updateBulkPerioadApprovalAsync(periodApprovals?: PerformanceFormPeriodApprovalRequestDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/UpdateBulkPerioadApprovalAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = periodApprovals;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param periodApprovals 
   */
  updatePeriodApprovalChangesByPerformanceFormId(periodApprovals?: Array<PerformanceFormPeriodApprovalInputDto>, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/UpdatePeriodApprovalChangesByPerformanceFormId`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = periodApprovals;
    query = query.withOptions(options);

    return query.firstAsync();
  }


  
  /**
   * @param performanceFormIds
   */
  sendPerformanceFormBulkApprovalAsync(performanceFormIds?: Array<string>, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriodApproval/SendPerformanceFormBulkApprovalAsync`
    let query = this.createQuery<boolean>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = performanceFormIds
    query = query.withOptions(options)

    return query.firstAsync()
  }

}
